// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  mockUrl: 'https://tech.virtueanalytics.com/wepcsr/assets/api/mockjson',
  serverUrl: 'https://tech.virtueanalytics.com/csrservice',
  // serverUrl: 'http://localhost:8080/csrservice',
  efcURL:'https://tech.virtueanalytics.com/efcApp/EFC',
  // efcURL:'https://tech.virtueanalytics.com/efc/#/student',
  logoURL: '/wepcsr',
  envName: 'Dev',
  displayName : 'Virtue Analytics',
  pageTitle : 'Marquette University - CSR',
  allEnvDisplay : {'wallin' : 'Wallin Education Partners', 
    'collegepossible' : 'College Possible',
    'cristorey' : 'Cristo Rey Jesuit High School',
    'allinmilwaukee' : 'All In Milwaukee Graduate College',
    'top5' : 'Vitue Top5 Colleges',
    'Dev' : 'Virtue Analytics',
    'Prod': 'Virtue Analytics'
   },
   clr:false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
